var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("h2", { staticClass: "m-n" }, [_vm._v("だれでも掲示板")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row m-t-md" }, [
      _c("div", { staticClass: "hpanel" }, [
        _c("div", { staticClass: "panel-body p-xs" }, [
          _c("div", { staticClass: "text-left text-title" }, [
            _c("b", [_vm._v(_vm._s(_vm.commentOwner.title))])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "hpanel" }, [
        _c("div", { staticClass: "panel-body p-xs" }, [
          _c("div", { staticClass: "text-left" }, [
            _c("span", { staticClass: "seller_name" }, [
              _vm._v(_vm._s(_vm.commentOwner.seller.seller_id))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-left m-l-md m-t-sm content_comment" },
            [_vm._v(_vm._s(_vm.commentOwner.content))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-left m-l-md m-t-sm created_date" }, [
            _vm._v(_vm._s(_vm.commentOwner.createdAt))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-left m-l-md m-t-sm flexbox" }, [
            !_vm.isLiked
              ? _c("img", {
                  attrs: {
                    src: "/static/dists/img/ic_unlike.png",
                    width: "30px"
                  },
                  on: { click: _vm.likeRequest }
                })
              : _c("img", {
                  attrs: {
                    src: "/static/dists/img/ic_liked.png",
                    width: "30px"
                  }
                }),
            _vm._v(" "),
            _c("span", { staticClass: "like_count m-l-sm" }, [
              _c("span", { staticClass: "like_number" }, [
                _vm._v(
                  _vm._s(_vm.formatAmount(_vm.commentOwner.likesCount)) + " "
                )
              ]),
              _vm._v("  いいね")
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "hpanel" }, [
        _c("div", { staticClass: "panel-body p-xs" }, [
          _c("div", { staticClass: "text-left" }, [
            _c("span", { staticClass: "seller_name" }, [
              _vm._v(_vm._s(_vm.userInfo.sellerId))
            ])
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.commentContent,
                expression: "commentContent"
              }
            ],
            staticClass: "form-control m-t-sm comment_box",
            attrs: { type: "text", placeholder: "ここにコメント..." },
            domProps: { value: _vm.commentContent },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.commentContent = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-warning m-t-sm",
              attrs: { type: "button", disabled: !_vm.commentContent },
              on: { click: _vm.postComment }
            },
            [_vm._v("\n          コメント\n        ")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "hpanel" }, [
        _c(
          "div",
          { staticClass: "panel-body p-xs" },
          [
            _c("div", { staticClass: "text-left flexbox" }, [
              _c("span", { staticClass: "seller_name" }, [
                _vm._v("アクティビティ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "m-l-md sort_comment" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.getCommentOwner(true)
                      }
                    }
                  },
                  [_vm._v("新しい投稿順")]
                ),
                _vm._v(" ／ "),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.getCommentOwner(false)
                      }
                    }
                  },
                  [_vm._v("古い投稿順")]
                )
              ])
            ]),
            _vm._v(" "),
            _vm._l(_vm.commentArr, function(cmt, index) {
              return [
                _c(
                  "div",
                  {
                    key: "cmt" + index,
                    staticClass: "m-l-xl m-r-xl p-sm align_baseline",
                    class: {
                      border_comment: index != _vm.commentArr.length - 1
                    }
                  },
                  [
                    _c("div", { staticClass: "comment-index" }, [
                      _vm.isNewest
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.commentArr.length - index) + ".")
                          ])
                        : _c("span", [_vm._v(_vm._s(index + 1) + ".")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "comment-item" }, [
                      _c("div", { staticClass: "text-left" }, [
                        _c("span", { staticClass: "seller_name" }, [
                          _vm._v(_vm._s(cmt.seller.seller_id))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "text-left m-t-xs created_date" },
                          [_vm._v(_vm._s(cmt.createdAt))]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-left m-t-xs content_comment" },
                        [_vm._v(_vm._s(cmt.comment))]
                      )
                    ])
                  ]
                )
              ]
            })
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row m-t-md" }, [
      _c("a", { attrs: { href: "/request" } }, [_vm._v("一覧へ戻る")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cb86cd1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb86cd1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/request/RequestComment.vue
// module id = null
// module chunks = 